import { DomesticCustomer } from "./domestic-customer";
const GroundHandler = DomesticCustomer;

export {
    GroundHandler
}